<template>
  <v-card outlined class="mb-4">
    <v-card-title class="py-3">
      <v-icon color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
      Classificar Ticket
    </v-card-title>
    <v-divider />
    <v-card-text>
      <p class="body-2 text--secondary mb-4">
        Este ticket foi criado via integração e pode estar sem provedor e/ou designação.
        Preencha apenas os campos pendentes abaixo para classificar o ticket antes de avançar.
      </p>

      <v-row>
        <v-col cols="12" sm="6" v-if="faltaProvedor">
          <v-autocomplete
            v-model="form.ctrl_provedor_id"
            :items="listaDeProvedores"
            item-text="nome"
            item-value="id"
            label="Provedor"
            placeholder="Selecione o provedor"
            outlined
            dense
            :loading="loadingProvedores"
            :rules="[v => !!v || 'Informe o provedor']"
            @change="onProvedorChange"
          />
        </v-col>
        <v-col cols="12" sm="6" v-if="faltaDesignacao">
          <v-autocomplete
            v-model="form.designacao_claro"
            :items="designacoesFiltradas"
            item-text="designacao"
            item-value="id"
            label="Designação"
            placeholder="Digite pelo menos 3 letras"
            outlined
            dense
            no-filter
            :loading="loadingDesignacao || carregandoDesignacoes"
            :rules="[v => !!v || 'Informe a designação']"
            @update:search-input="buscarDesignacoes"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider />
    <v-card-actions class="pa-3">
      <v-spacer />
      <v-btn
        depressed
        color="primary"
        :loading="salvando"
        :disabled="!formValido"
        @click="classificar"
      >
        <v-icon left>mdi-check</v-icon>
        Classificar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ClassificarTicketComponent',

  props: {
    pcoTarefaId: {
      type: [Number, String],
      required: true
    },
    dadosFichaTecnica: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      form: {
        ctrl_provedor_id: null,
        designacao_claro: null
      },
      salvando: false,
      carregandoDesignacoes: false,
      timeoutBusca: null
    }
  },

  async created () {
    await this.listarProvedores()
  },

  computed: {
    ...mapGetters('ctrlProvedores', ['listaDeProvedores', 'loadingProvedores']),
    ...mapGetters('ctrlDesignacao', ['listaDeDesignacao', 'loadingDesignacao']),

    provedorRecuperacao () {
      return this.dadosFichaTecnica?.workflow?.provedor_recuperacao || {}
    },

    faltaProvedor () {
      return !this.provedorRecuperacao.ctrl_provedor_id
    },

    faltaDesignacao () {
      return !this.provedorRecuperacao.designacao_claro
    },

    designacoesFiltradas () {
      return this.listaDeDesignacao || []
    },

    formValido () {
      if (!this.faltaProvedor && !this.faltaDesignacao) {
        return false
      }

      if (this.faltaProvedor && !this.form.ctrl_provedor_id) {
        return false
      }

      if (this.faltaDesignacao && !this.form.designacao_claro) {
        return false
      }

      return true
    }
  },

  methods: {
    ...mapActions('ctrlProvedores', ['listarProvedores']),
    ...mapActions('ctrlDesignacao', ['listarDesignacao']),
    ...mapActions('fichaTecnicaWorkflow', ['classificarTicket']),

    onProvedorChange () {
      this.form.designacao_claro = null
    },

    buscarDesignacoes (termo) {
      if (this.timeoutBusca) {
        clearTimeout(this.timeoutBusca)
      }

      if (!termo || termo.length < 3) {
        return
      }

      this.timeoutBusca = setTimeout(async () => {
        this.carregandoDesignacoes = true
        try {
          await this.listarDesignacao({
            page: 1,
            current_page: 1,
            per_page: 50,
            designacao: termo
          })
        } catch (error) {
          console.error('Erro ao buscar designações:', error)
        } finally {
          this.carregandoDesignacoes = false
        }
      }, 300)
    },

    async classificar () {
      if (!this.formValido) return

      const payload = {
        pcoTarefaId: this.pcoTarefaId
      }

      if (this.faltaProvedor) {
        payload.ctrl_provedor_id = this.form.ctrl_provedor_id
      }

      if (this.faltaDesignacao) {
        payload.designacao_claro = this.form.designacao_claro
      }

      this.salvando = true
      try {
        await this.classificarTicket(payload)
        this.$emit('classificado')
      } catch (e) {
        // erro já tratado pelo HttpClient/action
      } finally {
        this.salvando = false
      }
    }
  }
}
</script>
